import LinkCard from "../../components/LinkCard";

export default function Home() {
  return (
    <div>
      <h1>Other projects</h1>
      <div style={{ display: 'flex' }}>
        <LinkCard href="https://a16.xyz">
          <h3>Editor</h3>
        </LinkCard>
        <LinkCard href="https://dnd.a16.xyz">
          <h3>Drag and drop</h3>
        </LinkCard>
      </div>
    </div>
  )
}
